var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.condition)?_c('li',{staticClass:"anchor-nav__item self-stretch py-3 transition-all cursor-pointer\n  text-EXPONDO-grey-60 text-sm relative hover:text-EXPONDO-black mt-auto",class:{
    'anchor-nav__item--active text-EXPONDO-black': _vm.isItemActive
  },on:{"click":_vm.scrollToAnchor}},[_c('span',[_vm._v(_vm._s(_vm.item.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }